import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
import { Button, Card, CardActionArea, CardActions, CardContent, CircularProgress, Grid, List, ListItem, ListItemText, LinearProgress } from '@material-ui/core';
import ErrorOutlineRounded from '@material-ui/icons/ErrorOutlineRounded'
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline'
import { GenerarMatriculaLogic } from '../../../view-model/Matricula/Matricula.logic';
import d1 from '../../../../assets/dist/svg/main.svg';
type Props = {
}
export const eCertResult: React.FC<Props> = () => {

    return (
        <>
        </>
    )
}
export default eCertResult;
